/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createChainClass } from '../../factoriesAny.js';
export var ChainDependencies = {
  createChainClass
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesChainClass.generated.js
// module id = null
// module chunks = 